module.exports = __webpack_public_path__ + "img/Client.dfd1415f.png";